/* =============================================================================
   Commissions Form — commissions.js

   EMAIL SUBJECT & BODY (edit here when switching email platforms):
   Subject: "New commission inquiry — [first name], [piece type]"
   Body: All fields labeled and included via Shopify contact form.
   ============================================================================= */

(function () {
  var form = document.getElementById('po-comm-form');
  var stepIndicator = document.getElementById('po-comm-step-num');
  if (!form) return;

  var currentStep = 1;
  var totalVisibleSteps = 5; // steps 1-5 shown in indicator; 6 is confirmation

  /* --- Step navigation --- */
  function showStep(n, skipScroll) {
    var steps = form.querySelectorAll('.po-comm__step');
    steps.forEach(function (s) { s.classList.remove('is-active'); });

    var target = form.querySelector('[data-step="' + n + '"]');
    if (!target) return;

    // Fade in
    target.style.opacity = '0';
    target.classList.add('is-active');
    requestAnimationFrame(function () {
      target.style.opacity = '1';
    });

    currentStep = n;

    // Intro copy only belongs on the landing step — hide it once the user
    // moves into the form so it doesn't clutter every step
    var intro = document.querySelector('.po-comm__intro');
    if (intro) intro.style.display = n === 1 ? '' : 'none';

    // "Customs" hero shrinks to a small label once past the landing step
    var hero = document.querySelector('.po-comm__hero');
    if (hero) hero.classList.toggle('is-compact', n !== 1);

    // Image is only needed on the welcome step
    var image = document.querySelector('.po-comm__right');
    if (image) image.style.display = n === 1 ? '' : 'none';

    // Update indicator (hide on step 1 and 6)
    var indicator = document.querySelector('.po-comm__step-indicator');
    if (n === 1 || n === 6) {
      indicator.style.display = 'none';
    } else {
      indicator.style.display = 'block';
      stepIndicator.textContent = n - 1;
    }

    // Scroll the section back to the top on every step change. Target the
    // whole section (#po-comm), not the form/content inside it — content is
    // vertically centered now, so its own position shifts per step, but the
    // section's top edge stays put regardless of how tall its content is.
    // Goes through Lenis (this site's scroll library) rather than native
    // scrollIntoView, since Lenis hijacks scroll and fights calls that don't.
    if (!skipScroll) {
      var section = document.getElementById('po-comm');
      if (section) {
        if (window.lenis) {
          // Hiding/showing the image above just changed the page's layout.
          // Lenis caches scroll dimensions and doesn't know that happened
          // yet, so without this it scrolls to where the section's top USED
          // to be, landing partway down the now-shorter page.
          window.lenis.resize();
          window.lenis.scrollTo(section);
        } else {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  }

  /* --- Validation --- */
  function validateStep(n) {
    var step = form.querySelector('[data-step="' + n + '"]');
    if (!step) return true;

    var valid = true;

    // Check required radio groups
    var radioGroups = {};
    step.querySelectorAll('input[type="radio"][required]').forEach(function (r) {
      radioGroups[r.name] = true;
    });

    Object.keys(radioGroups).forEach(function (name) {
      var checked = step.querySelector('input[name="' + name + '"]:checked');
      var fieldset = step.querySelector('input[name="' + name + '"]').closest('.po-comm__field');
      if (!checked) {
        valid = false;
        if (fieldset) fieldset.classList.add('has-error');
      } else {
        if (fieldset) fieldset.classList.remove('has-error');
      }
    });

    // Check required text/email inputs and textareas
    step.querySelectorAll('input[required]:not([type="radio"]):not([type="checkbox"]), textarea[required]').forEach(function (input) {
      var field = input.closest('.po-comm__field');
      if (!input.value.trim()) {
        valid = false;
        if (field) field.classList.add('has-error');
      } else {
        if (field) field.classList.remove('has-error');
      }
    });

    // Email format check
    var emailInput = step.querySelector('input[type="email"]');
    if (emailInput && emailInput.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value)) {
      valid = false;
      var field = emailInput.closest('.po-comm__field');
      if (field) field.classList.add('has-error');
    }

    return valid;
  }

  /* --- Button handlers --- */
  form.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-next]');
    if (btn) {
      e.preventDefault();
      var nextStep = parseInt(btn.getAttribute('data-next'));
      if (validateStep(currentStep)) {
        showStep(nextStep);
      }
      return;
    }

    var backBtn = e.target.closest('[data-prev]');
    if (backBtn) {
      e.preventDefault();
      showStep(parseInt(backBtn.getAttribute('data-prev')));
      return;
    }
  });

  /* --- Conditional field: specific date --- */
  form.addEventListener('change', function (e) {
    if (e.target.name === 'contact[timeline]') {
      var dateField = document.getElementById('comm-date-field');
      if (e.target.value === 'Specify a date') {
        dateField.style.display = 'block';
      } else {
        dateField.style.display = 'none';
      }
    }
  });

  /* --- File upload display: thumbnails + remove --- */
  var fileInput = document.getElementById('comm-files');
  var fileList = document.getElementById('comm-file-list');
  if (fileInput && fileList) {
    var selectedFiles = [];

    var syncFileInput = function () {
      var dt = new DataTransfer();
      selectedFiles.forEach(function (f) { dt.items.add(f); });
      fileInput.files = dt.files;
    };

    var renderFileList = function () {
      fileList.innerHTML = '';
      selectedFiles.forEach(function (f, i) {
        var item = document.createElement('div');
        item.className = 'po-comm__file-item';

        if (f.size > 10 * 1024 * 1024) {
          var warning = document.createElement('span');
          warning.className = 'po-comm__file-error';
          warning.textContent = f.name + ' — too large (max 10mb)';
          item.appendChild(warning);
        } else if (f.type.indexOf('image/') === 0) {
          var img = document.createElement('img');
          img.className = 'po-comm__file-thumb';
          img.src = URL.createObjectURL(f);
          img.alt = f.name;
          item.appendChild(img);
        } else {
          var name = document.createElement('span');
          name.className = 'po-comm__file-name';
          name.textContent = f.name;
          item.appendChild(name);
        }

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'po-comm__file-remove';
        remove.setAttribute('aria-label', 'Remove ' + f.name);
        remove.textContent = '×';
        remove.addEventListener('click', function () {
          selectedFiles.splice(i, 1);
          syncFileInput();
          renderFileList();
        });
        item.appendChild(remove);

        fileList.appendChild(item);
      });
    };

    fileInput.addEventListener('change', function () {
      selectedFiles = selectedFiles.concat(Array.from(fileInput.files)).slice(0, 3);
      syncFileInput();
      renderFileList();
    });
  }

  /* --- Form submission --- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (!validateStep(5)) return;

    // Set dynamic subject line
    var name = form.querySelector('[name="contact[first_name]"]').value;
    var piece = form.querySelector('[name="contact[piece_type]"]:checked');
    var pieceVal = piece ? piece.value : 'unspecified';
    document.getElementById('po-comm-subject').value =
      'New commission inquiry — ' + name + ', ' + pieceVal;

    // Collect all form data
    var formData = new FormData(form);
    var jsonData = {};
    formData.forEach(function (value, key) {
      var clean = key.replace('contact[', '').replace(']', '').replace('[]', '');
      if (jsonData[clean]) {
        if (!Array.isArray(jsonData[clean])) jsonData[clean] = [jsonData[clean]];
        jsonData[clean].push(value);
      } else {
        jsonData[clean] = value;
      }
    });
    jsonData.submitted_at = new Date().toISOString();
    jsonData.submission_id = 'PO-' + Date.now().toString(36).toUpperCase();

    // 1. Send to Shopify contact form (email)
    fetch('/contact', {
      method: 'POST',
      body: formData,
    }).catch(function () {});

    // 2. Send to webhook (if configured)
    var webhookUrl = window.__PO_WEBHOOK;
    if (webhookUrl && webhookUrl.length > 0) {
      fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(jsonData),
      }).catch(function () {
        // Silently skip if webhook fails
      });
    }

    // Show confirmation
    showStep(6);
  });

  /* --- Init --- */
  showStep(1, true);
})();
